import { Injectable } from '@angular/core';
import { sentryHelper } from '@shared/helpers/sentry.helper';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor(private readonly _logger: NGXLogger) {}

  public error(type: string, request: string, err: any) {
    this._logger.error(type, `${request} failed`, err);
    sentryHelper.captureException(err);
  }

  public info(type: string, request: string, res: any) {
    this._logger.info(type, request, res);
  }
}
